import { GridPaginationModel, GridRowSelectionModel, GridSortModel } from '@mui/x-data-grid';
import { enqueueSnackbar } from 'notistack';
import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router';
import { useLpEventsStore } from 'src/store/benefits/lp-events.store';
import { useMyDataStore } from 'src/store/me/me.store';
import { LP_EVENT_COLUMNS } from './components/events-lp-columns';

export default function useLPEventsList() {
  const navigate = useNavigate();
  const { getLpEventsList, lpEventsList, isLoadingLpEventsList } = useLpEventsStore();
  const me = useMyDataStore((state) => state.me);
  const permissions = me?.cnAdminInfo?.permissions?.benefits;
  const canCopy = Boolean(permissions?.create && me?.roles.includes('cn_admin'));
  const [search, setSearchValue] = useState('');
  const [selectedRows, setSelectedRows] = useState<GridRowSelectionModel>([]);
  const [sortModel, setSortModel] = useState<GridSortModel>([{ field: 'name', sort: 'asc' }]);
  const [paginationModel, setPaginationModel] = useState<GridPaginationModel>({
    page: 0,
    pageSize: 10,
  });

  useEffect(() => {
    getLpEventsList().catch((error) => {
      enqueueSnackbar(error.message || 'Erro ao carregar os eventos do Viva Visitante.', { variant: 'error' });
    });
  }, [getLpEventsList]);

  const rows = useMemo(() => {
    const query = search.trim().toLocaleLowerCase('pt-BR');
    return lpEventsList
      .map((event) => ({ ...event, id: event._id, editedByName: event.editedBy?.name || '' }))
      .filter((event) =>
        [event.name, event.detail, event.editedByName].some((value) =>
          String(value || '')
            .toLocaleLowerCase('pt-BR')
            .includes(query)
        )
      );
  }, [lpEventsList, search]);

  return {
    columns: LP_EVENT_COLUMNS,
    rows,
    total: lpEventsList.length,
    isLoading: isLoadingLpEventsList,
    navigate,
    permissions,
    canCopy,
    selectedEvent: lpEventsList.find((event) => event._id === selectedRows[0]),
    selectedRows,
    setSelectedRows,
    search,
    setSearch: (value: string) => {
      setSearchValue(value);
      setPaginationModel((current) => ({ ...current, page: 0 }));
    },
    sortModel,
    setSortModel,
    paginationModel,
    setPaginationModel,
  };
}
